import { Popconfirm } from "antd";
import React, { useEffect, useMemo, useState, useCallback } from "react";
import { CloseImage, StyTable } from "./style";
import {
  MemorizedPositionData,

  PositionQuantity,
  PositionSocketData,
} from "../../components/SocketLiveData";
import closeImage from "../../assets/icons/closeIcon.svg";
import { valanBillDate } from "../../components/CommanFuction/CommanFunction";
import { ScriptName } from "./Components/tradePositionComponent";
import { useSelector } from "react-redux";
import { MarketTableTag } from "../MarketWatch/style";
import { marketTag } from "../../Helper/constant";

const PositionTable = (props) => {
  const {
    position,
    value,
    el,
    currentPriceRef,
    closePosition,
    clearSelect,
    setClearSelect,
    isBroker,
  } = props;

  // state
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);

  //life cycle
  useEffect(() => {
    if (clearSelect) {
      setSelectedRowKeys([]);
      setClearSelect(false);
    }
  }, [clearSelect, setClearSelect]);

  //redux
  const userIP = useSelector((state) => state.authSlice?.user?.userIP) || "";

  // Memoized handlers for better performance
  const handleClose = useCallback(async (record) => {
    const obj = {
      deviceType: "web",
      positionIds: [
        {
          id: record?._id,
          tradePrice: 0,
          High: 0,
          low: 0,
        },
      ],
      tradeIpAddress: userIP,
      type: "Close",
    };

    const closeArray = position[el]?.length === 1 ? [el] : [];
    await closePosition(obj, closeArray);
  }, [userIP, position, el, closePosition]);

  // detect small screens
  const isSmallScreen = typeof window !== "undefined" && window.innerWidth <= 768;

  // Memoized columns for better performance
  const columns = useMemo(() => {
    const baseColumns = [
      {
        title: "No.",
        dataIndex: "index",
        key: "index",
        align: "center",
        width: isSmallScreen ? 40 : 50,
        render: (text, record, index) => index + 1,
      },
     
      {
        title: "CLIENT INFO",
        dataIndex: "client",
        key: "client",
        width: isSmallScreen ? "7rem" : "10rem",
        render: (text, record) => (
          <span>{`${record?.user?.[0]?.userId} (${record?.user?.[0]?.accountName})`}</span>
        ),
      },
      {
        title: "SCRIPT NAME",
        dataIndex: "symbolName",
        key: "symbol",
        align: "left",
        width: isSmallScreen ? "9rem" : "12rem",
        sorter: {
          compare: (a, b) => a?.symbolName?.localeCompare(b?.symbolName),
        },
        defaultSortOrder: "ascend",
        render: (text, record) => {
          const date = valanBillDate(record?.expiryDate, false);
          const name = ScriptName(record);
          return (
            <>
            <div style={{ textAlign: "left",display: "flex"}}>
              {name} 
            </div>
            <div style={{ textAlign: "left", fontSize: "10px"}}>
              {date}
            </div>
            </>
          );
        },
      },
      {
        title: "",
        dataIndex: "positionType",
        key: "positionType",
        align: "center",
        width: isSmallScreen ? "3rem" : "4rem",
        render: (text, record) => 
        <div style={{ display: "flex"}}>
        <MarketTableTag color="magenta" bordered={false}>
                  {marketTag[record?.marketName]}
                </MarketTableTag>
        <MarketTableTag color={record?.positionType==="market"?"green":"red"} bordered={false}>
                  {record?.positionType==="market"?"M":"I"}
                </MarketTableTag>
        </div>
      },
      {
        title: "BUY QTY.(AVG)",
        dataIndex: "totalBuyQuantity",
        key: "totalBuyQuantity",
        align: "center",
        width: isSmallScreen ? "8rem" : "10rem",
        render: (text, record) => (
          <PositionQuantity
            id={record?._id}
            market={record?.marketName}
            type={"totalBuyQuantity"}
            lot={"totalBuyLot"}
            average={"buyAverage"}
          />
        ),
      },

      {
        title: "SELL QTY.(AVG)",
        dataIndex: "totalSellQuantity",
        key: "totalSellQuantity",
        align: "center",
        width: isSmallScreen ? "8rem" : "10rem",
        render: (text, record) => (
          <PositionQuantity
            id={record?._id}
            market={record?.marketName}
            type={"totalSellQuantity"}
            lot={"totalSellLot"}
            average={"sellAverage"}
          />
        ),
      },
     
      {
        title: "OUTSTANDING (NET)",
        dataIndex: "netQ",
        align: "center",
        key: "netQ",
        width: isSmallScreen ? "8rem" : "10rem",
        
        render: (text, record) => {
          return (
            <PositionQuantity
              id={record?._id}
              market={record?.marketName}
              type={"outstandingQuantity"}
              lot={"outstandingLot"}
              average={"BE_Avg"}
            />
          );
        },
      },
      
      {
        title: "LIVE",
        dataIndex: "cR",
        key: "cR",
        align: "center",
        render: (text, record) => {
          if (record?.status === "Close") {
            return "-";
          } else {
            return (
              <MemorizedPositionData id={record?._id} type={"LiveValue"} />
            );
          }
        },
      },
      {
        title: "P & L",
        dataIndex: "m2M",
        align: "end",
        key: "m2M",

        render: (text, record) => {
          return <PositionSocketData id={record?._id} type={"currentPNL"} />;
        },
      },
      {
        title: "EXIT",
        dataIndex: "close",
        key: "close",
        align: "center",
        width: isSmallScreen ? 40 : 50,
        render: (imageUrl, record) => {
          if (record?.status === "Close") {
            return "-";
          } else {
            return (
              <>
                <Popconfirm
                  title={"Close Position"}
                  description={"Are you sure to close position ?"}
                  onConfirm={() => handleClose(record)}
                  placement="topRight"
                >
                  <CloseImage
                    style={{ cursor: "pointer" }}
                    src={closeImage}
                    alt="Product"
                  />
                </Popconfirm>
              </>
            );
          }
        },
      },
  
    ];
    if (isBroker) {
      return baseColumns.filter((el) => el?.dataIndex !== "close");
    }
    return baseColumns;
  }, [isBroker, isSmallScreen, handleClose]);

  //state
  const [positionColumn, setPositionColumn] = useState(columns);

  //use effect
  useEffect(() => {
    if (value?.radioClient !== 1) {
      setPositionColumn(() => {
        return columns.filter((el) => el.dataIndex !== "client");
      });
    } else {
      setPositionColumn(columns);
    }
  }, [value?.radioClient, position, columns]);

  const rowSelection = useMemo(() => ({
    selectedRowKeys,
    columnWidth: isSmallScreen ? 32 : 40,
    onChange: (selectedRowKeys, selectedRows) => {
      const positionSelected = selectedRows.map((item) => ({
        id: item._id,
        symbol: item.symbol,
        marketName: item.marketName
      }));
      currentPriceRef.current[el] = positionSelected;
      setSelectedRowKeys(selectedRowKeys);
    },
    getCheckboxProps: (record) => ({
      disabled: record.status === "Close",
    }),
  }), [selectedRowKeys, el, isSmallScreen, currentPriceRef]);

  // const rowClassName = (record) => {
  //   switch (record?.type) {
  //     case "buy":
  //       return "buy-row";
  //     case "sell":
  //       return "sell-row";
  //     case "close":
  //       return "close-row";
  //     default:
  //       return "";
  //   }
  // };

  return (
    <StyTable
      className="custom-virtual-table"
      virtual
      columns={positionColumn}
      {...(!isBroker ? { rowSelection: rowSelection } : {})}
      // rowClassName={rowClassName}
      dataSource={position[el]}
      pagination={false}
      sortDirections={["ascend", "descend"]}
      scroll={{ x: isSmallScreen ? 900 : 1300, }}
      rowKey="_id"
      // locale={{ emptyText: isLoading ? <Skeleton active /> : null }}
    />
  );
};

export default React.memo(PositionTable);
